const Video = {
	init: function () {
		document.addEventListener('DOMContentLoaded', () => {
			document.querySelectorAll('.modal-video').forEach(modal => {
				jQuery(modal).on('shown.bs.modal', async function () {
					await modal.querySelector('video').play();
				});
				jQuery(modal).on('hide.bs.modal', function () {
					modal.querySelector('video').pause();
				});
			});
		});
	},
};

export default Video;
